<template>
  <div class="comp-empty">
    <div class="empty-bg" :class="[emptyStatus.class]"></div>
    <p class="msg">{{emptyStatus.msg}}</p>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'CEmpty',
    props: {
      text: {
        type: String,
        default: '抱歉，暂无数据'
      }
    },
    computed: {
      ...mapState(['requestMsg']),
      emptyStatus () {
        console.log('requestMsg', this.requestMsg)
        let text = this.text
        let msg = this.requestMsg.msg || text
        let code = this.requestMsg.code
        return _.assign({}, this.requestMsg || {}, {
          msg: msg === '数据为空' ? text : msg,
          class: code === 500 ? 'bg-500' : 'bg-401'
        })
      }
    }
  }
</script>

<style lang="less">
  .comp-empty {
    text-align: center;

    .empty-bg {
      width: 160px;
      height: 160px;
      background: url(../assets/default/data_empty2.png) center center no-repeat;
      background-size: contain;
      display: block;
      margin: 0 auto;

      &.bg-500 {
        background-image: url(../assets/default/data_server_busy.png);
      }

      &.bg-401 {
        background-image: url(../assets/default/data_empty2.png);
      }
    }

    &.vertical-middle {
      padding-top: 50vh;
      transform: translateY(-50%);
    }

    .msg {
      color: #bbb;
    }
  }
</style>
